<template>
<div class="review-list-cont online-studyEvaluate">
  <div class="review-title review-title-adds">
    <p>{{$store.state.currentChild.classcode_name}}</p>
    <em @click="bakToPrev" class="back_arrow"></em>
  </div>
  <div style="height: calc(100% - 65px);">
    <ScrollBox @getData="getData">
      <div class="review-list-cont__box">
        <!-- <router-link :to="{path: '/studyEvaluate/evaluateChild'}" tag="div" class="item">
            <div class="img-box">
              <img src="@/assets/images/studyCenter/home/icon-book.png" alt />
            </div>
            <p>Happy Phonics</p>
          </router-link> -->
        <div v-if="materialList.length == 0 && loadFinish" class="no-pc-box">
          <EmptyTip :emptyTip="$t('blendType.noPCTxt')" />
        </div>
        <template v-else>
          <div class="item" v-for="(item,index) of materialList" :key="index" @click="materialClick(item,index)">
            <div class="img-box">
              <img :src="item.textbook_coverminimg" alt />
            </div>
            <p>{{item.textbook_enname}}</p>
          </div>
        </template>
      </div>
    </ScrollBox>
  </div>
</div>
</template>

<script>
import ScrollBox from "@/components/ScrollBox";
import evaluationStore from "@/views/StudyCenter/Evaluation/Evaluation";
import EmptyTip from "@/components/Empty";

export default {
  name: "evaluationList",
  data() {
    return {
      title: "小儿童美语二级",
      loadFinish: false,
      studentInfo: {
        token: '',
        member_id: '',
        student_id: '', //学生ID
        textbook_id: '', //班别编号
      },
      materialList: [],
    };
  },
  components: {
    ScrollBox,
    EmptyTip
  },
  mounted() {},
  updated() {},
  created() {
    this.studentInfo.token = this.$store.state.token;
    this.studentInfo.member_id = this.$store.state.member_id;
    this.studentInfo.student_id = this.$store.state.currentChild.student_id;
    this.studentInfo.classcode_branch = this.$store.state.currentChild.classcode_branch;
    console.log(this.$store.state.currentChild.classcode_branch,'课程别')
    this.getStuTexts();
  },
  watch: {},
  computed: {},
  methods: {
    bakToPrev() {
      this.$router.push({
        path: "/StudyCenter",
      });
    },
    getData() {
      console.log("getData");
    },
    //获取 测评 教材信息
    getStuTexts() {
       this.$store.dispatch("setLoadingStatus", true);
      evaluationStore
        .getStuTexts({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          classcode_branch: this.studentInfo.classcode_branch,
        })
        .then(res => {
          if (res.data.error == 0) {
            console.log(res.data.result.list);
            this.materialList = [...res.data.result.list];
          }
          this.$store.dispatch("setLoadingStatus", false);
          this.loadFinish = true
        });
    },
    //点击 进入 教材信息详情
    materialClick(item, index) {
      console.log(item, index)
      console.log(item.textbook_cnname)
      this.$router.push({
        path: "/studyEvaluate/evaluateChild",
        query: {
          textbook_id:item.textbook_id,
          textbook_cnname:escape(item.textbook_cnname),
        }
      });
      //存储教材id
      this.$Tool.setStorage("textBookId",item.textbook_id);
      this.$store.dispatch("settextBookId",item.textbook_id);
      //存储教材名称
      this.$Tool.setStorage("textbookCnname",item.textbook_cnname);
      this.$store.dispatch("settextbookCnname",item.textbook_cnname);
    },
  }
};
</script>

<style lang="less" scoped>
.review-list-cont {
  height: 100%;

  .review-list-cont__box {
    width: 716px;
    margin: 0 auto;
    padding: 15px 0 15px;
    display: flex;
    flex-wrap: wrap;

    .no-pc-box {
      display: flex;
      width: 100%;
      padding-top: 150px;
      justify-content: center;
    }

    .item {
      width: 222px;
      margin-bottom: 15px;
      margin-right: 25px;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .img-box {
        height: 298px;
        width: 100%;
        overflow: hidden;
        border-radius: 10px 10px 0 0;
        position: relative;

        img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
          max-width: 100%;
          max-height: 100%;
        }
      }

      p {
        height: 56px;
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        background-color: #fff;
        border-radius: 0 0 10px 10px;
        text-align: center;
      }
    }
  }

  @media screen and (max-width: 780px) {
    .review-list-cont__box {
      width: 500px;
      
      .item {
        width: 150px;

        .img-box {
          height: 240px;
        }

        p {
          height: 40px;
        }
      }
    }
  }

  @media screen and (min-width: 1350px) {
    .review-list-cont__box {
      width: 1210px;

      .item {
        &:nth-child(3n) {
          margin-right: 25px;
        }

        &:nth-child(5n) {
          margin-right: 0;
        }
      }
    }
  }

  @media screen and (min-width: 1750px) {
    .review-list-cont__box {
      width: 1705px;

      .item {

        &:nth-child(3n),
        &:nth-child(5n) {
          margin-right: 25px;
        }

        &:nth-child(7n) {
          margin-right: 0;
        }
      }
    }
  }
}
.review-title-adds{
  height: 65px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 0 20px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    font-size: 16px;
    color: #181818;
    border-radius: 10px 10px 0 0;
    background-color: #fff;
    -webkit-box-shadow: 0 2px 5px 0 rgba(0,0,0,.05);
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.05);
    .back_arrow {
      width: 24px;
      height: 24px;
      background: url("../../../../assets/images/studyCenter/back-icon.png") center
        center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
}
</style>
